import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import {
  Card,
  Stack,
  Container,
  Typography,
  CircularProgress,
  Box,
} from "@mui/material";
import Scrollbar from "../components/scrollbar";
import { useSearchParams } from "react-router-dom";
import CoinTransactionsTable from "src/components/transactions-table/CoinTransactionsTable";
import { get } from "src/utils/networkUtils";

export default function CoinTransactionPage() {
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState(null);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.has("transaction_id")) {
      let transactionId = searchParams.get("transaction_id");
      get(`/admin/coins/transactions/${transactionId}`).then(function (
        response
      ) {
        setLoading(false);
        setRows([response.transaction]);
      });
    }
  }, [searchParams]);

  return (
    <>
      <Helmet>
        <title> Coins Transaction </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Coin Transaction
          </Typography>
        </Stack>

        <Card>
          {rows === null || loading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Scrollbar>
              <CoinTransactionsTable transactions={rows} />
            </Scrollbar>
          )}
        </Card>
      </Container>
    </>
  );
}
